// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l1-1";
export var messageSideRight = "_l1-2";
export var subscribeToBackInStockBubbleContainer = "_l1-0";